import React from "react"
import { Link } from "react-router-dom"
import SocialIcons from "./SocialIcons"
import Logoimage from "./Akoi-logo.png"

const Footer = () => {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="text-center bg-green-950  text-white font-roboto text-lg md:text-xl flex flex-col md:flex-wrap md:items-center py- px-4">
        {/* Logo and Description */}
        <div className="flex flex-col md:flex-row items-center md:w-[50%] mb-8">
          <img src={Logoimage} alt="logo" className="h-36 rounded-full mx-auto  md:mb-0" />
          <div className="text-wrap md:ml-8">
            <p className="text-sm md:text-base">
            Akoi Foundation promotes animal welfare, protects rights, raises awareness, and ensures love, care, and safety for neglected and suffering animals.
            </p>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="mb-8">
          <nav>
            <ul className=" space-y-2 md:space-y-0 md:flex md:flex-wrap md:justify-center md:gap-4">
              <Link to="/" onClick={() => scrollToTop()}><li className="cursor-pointer hover:underline">Home</li></Link>
              <Link to="/adopt" onClick={() => scrollToTop()}><li className="cursor-pointer hover:underline">Adopt</li></Link>
              <Link to="/page-donate" onClick={() => scrollToTop()}><li className="cursor-pointer hover:underline">Donate</li></Link>
              <Link to="/contact" onClick={() => scrollToTop()}><li className="cursor-pointer hover:underline">Contact</li></Link>
              <Link to="/term-condition" onClick={() => scrollToTop()}><li className="cursor-pointer hover:underline">Term and Condition</li></Link>
            </ul>
          </nav>
        </div>

        {/* Social Icons */}
        <div className="mb-8">
          <h1 className="font-bold text-xl md:text-2xl mb-4">Follow Us</h1>
          <ul className="flex justify-center space-x-2">
            <SocialIcons />
          </ul>
        </div>

        {/* Map Section */}
        <div className="w-full md:w-3/4 mx-auto">
          <h1 className="font-semibold text-xl md:text-2xl mb-4">Find Us</h1>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.2602486751166!2d77.143098!3d28.471708099999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1f0018d1e1b1%3A0x61b748b34e1f0616!2sAkoi%20Foundation!5e0!3m2!1sen!2sin!4v1736274063292!5m2!1sen!2sin"
            width="100%"
            height="300"
            className="border border-black rounded-md"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="bg-green-950 text-white font-semibold text-lg text-center py-4">
        <h1> Copyright © Akoi Foundation 2025. All rights reserved</h1>
      </div>
    </>
  );
};

export default Footer;
